
import React from 'react';
import StaffInfo from '../components/StaffInfo';
import Footer from '../components/Footer';


function StaffInfoPage() {
  return (
    <>
        <StaffInfo />
        <Footer />
    </>
  );
}


export default StaffInfoPage;
